import { render, staticRenderFns } from "./BatchCheckDuplicateBillsComp.vue?vue&type=template&id=5123b6b8&scoped=true"
import script from "./BatchCheckDuplicateBillsComp.vue?vue&type=script&lang=js"
export * from "./BatchCheckDuplicateBillsComp.vue?vue&type=script&lang=js"
import style0 from "./BatchCheckDuplicateBillsComp.vue?vue&type=style&index=0&id=5123b6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123b6b8",
  null
  
)

export default component.exports